import { render, staticRenderFns } from "./LookBookTopicItems.vue?vue&type=template&id=f7ae98f6&scoped=true&"
import script from "./LookBookTopicItems.vue?vue&type=script&lang=js&"
export * from "./LookBookTopicItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ae98f6",
  null
  
)

export default component.exports